var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extrato-item',{attrs:{"id":_vm.saidas ? 'saidas' : 'entradas',"headers":_vm.headers,"items":_vm.saidas ? _vm.movimentacoesSaidasManuais : _vm.movimentacoesEntradasManuais,"title":_vm.title,"negative":_vm.saidas},scopedSlots:_vm._u([{key:"valor",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.toReal(item.valor))+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }